import React, { Fragment, FunctionComponent, MouseEvent } from "react";

type LineProps = {
    readonly x1: number;
    readonly x2: number;
    readonly y1: number;
    readonly y2: number;
    readonly markerEnd?: string; // url k arrowhead
    readonly title: string;
    readonly className: string;
    readonly invisibleLineClassName: string;
    readonly onClick: (e: MouseEvent<SVGLineElement>) => void;
    readonly onDoubleClick: (e: MouseEvent<SVGLineElement>) => void;
};

export const Line: FunctionComponent<LineProps> = ({ x1, y1, x2, y2, markerEnd, title, className, invisibleLineClassName, onClick, onDoubleClick }) => (
    <Fragment>
        <line // obsahuje 2 line-y, protože ta druhá je větší a neviditelná (zvětšuje klikatelnout oblast, ale nezvětšuje čáru)
            {...{ x1, y1, x2, y2, markerEnd, className }} />
        <line
            className={invisibleLineClassName}
            {...{ x1, y1, x2, y2, onClick, onDoubleClick }}>
            <title>{title}</title>
        </line>
    </Fragment>
);
